var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.86 2.121a1.036 1.036 0 000-1.414.92.92 0 00-1.347 0L6.008 4.39 2.504.707a.92.92 0 00-1.347 0 1.036 1.036 0 000 1.414l4.175 4.385a.93.93 0 001.355-.001l4.173-4.384z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "static/media/chevron.72eebaf1.svg";
export { SvgChevron as ReactComponent };